// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DgrP","colBig":"styles_colBig__2llBJ","colSmall":"styles_colSmall__2Quqd"};